import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProgramFilterService {

  constructor() {}

   getFilteredProgramLevels(data: any, hiddenPrograms: any[] = []): any {
    const hiddenProgramNames = hiddenPrograms
      ?.map((p: any) => p?.sifProgramCode?.toLowerCase().trim())
      .filter(Boolean);

    const filteredLevels: any[] = [];

    for (const level of data.levels) {
      const programObj = level.Program?.[0] || {};
      const filteredAreas: string[] = [];
      const filteredProgramMap: any = {};

      for (const areaCode of level.areas) {
        const originalPrograms = programObj[areaCode] || [];

        const visiblePrograms = originalPrograms.filter(
          (p: any) => !hiddenProgramNames.includes(p.name?.toLowerCase().trim())
        );

        if (visiblePrograms.length > 0) {
          filteredAreas.push(areaCode);
          filteredProgramMap[areaCode] = visiblePrograms;
        }
      }

      if (filteredAreas.length > 0) {
        filteredLevels.push({
          ...level,
          areas: filteredAreas,
          Program: [filteredProgramMap]
        });
      }
    }

    return { levels: filteredLevels };
  }
}